import React from 'react';
import classNames from 'classnames';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { arrayOf, string } from 'prop-types';
import {
  Avatar,
  IconAnonym,
  ReviewRating,
  UserDisplayName,
  IconCheckmarkCircle,
  IconReport,
  IconPartner,
  NamedLink,
} from '../../components';
import { propTypes } from '../../util/types';
import { convertNumberToString } from '../../util/dates'

import css from './Reviews.module.css';

const Review = props => {
  const { review, intl } = props;
  const anonym = review?.attributes?.anonym;
  const reviewVerified = review?.attributes?.reviewVerified;
  const showReview = review?.attributes?.showReview;
  const date = review?.attributes?.createdAt;
  const dateString = intl.formatDate(date, { month: 'long', year: 'numeric' });

  const jobCompletedDate = review?.attributes?.jobCompletedDate;
  const jobCompletedDateString = jobCompletedDate && `${convertNumberToString(jobCompletedDate.month - 1)} ${jobCompletedDate.year}`

  const jobCompletedDateMessage = intl.formatMessage({ id: 'Reviews.jobCompletedDate' });
  const subcategories = review?.attributes?.subcategories;
  
  const reviewPartner = !!review?.attributes?.userType?.find(t => t === 'service-provider');

  const adminReview = review?.attributes?.adminReview;

  // if(showReview === false) {
  //   return null
  // }

  return (
    <div className={classNames(css.review, {[css.reviewBlocked]: showReview === false})}>
      {anonym || adminReview ? (
        <IconAnonym className={css.avatar} />
      ) : (
        review?.attributes?.authorImage?.url ? (
          <img
            className={css.avatar}
            src={review?.attributes?.authorImage?.url}
            alt="Review author img"
          />
        ) : (
          <Avatar className={css.avatar} user={review.author} />
        )
      )}
      <div className={css.reviewWrapper}>
        <div>
          <p className={css.reviewInfo}>
            {!anonym && (
              <>
                {review?.attributes?.companyName || review?.attributes?.authorDisplayName || <UserDisplayName user={review.author} intl={intl} />}
                <span className={css.separator}>•</span>
              </>
            )}

            {dateString}
            <span className={css.desktopSeparator}>•</span>
            <span className={css.desktopReviewRatingWrapper}>
              <ReviewRating
                rating={review.attributes.rating}
                className={css.desktopReviewRating}
                reviewStarClassName={css.reviewRatingStar}
              />
            </span>
          </p>
          <p className={css.reviewContent}>{review.attributes.content}</p>
          {!!subcategories && <p className={css.reviewInfo}>Categories: {subcategories}</p>}
          {!!jobCompletedDate && (
            <p className={css.jobCompletedDate}>
              <span className={css.jobCompletedLabel}>{jobCompletedDateMessage}</span>
              <span>{jobCompletedDateString}</span>
            </p>
          )}

          <NamedLink name="ContactPage" className={css.reportLink}>
            <IconReport />
            <FormattedMessage id="Reviews.report" />
          </NamedLink>
        </div>

        <div className={css.badgeHolder}>
          {reviewVerified && (
            <div className={css.verifiedBadge}>
              <IconCheckmarkCircle />
              <FormattedMessage id="Reviews.verified" />
            </div>
          )}

          {reviewPartner && (
            <div className={css.verifiedBadge}>
              <IconPartner />
              <FormattedMessage id="Reviews.partner" />
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

Review.propTypes = {
  review: propTypes.review.isRequired,
  intl: intlShape.isRequired,
};

const ReviewsComponent = props => {
  const { className, rootClassName, reviews, intl } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <ul className={classes}>
      {reviews.map((r,i) => {
        return (
          <li key={`Review_${r?.id?.uuid || 'dedicated_review'}_${i}`} className={css.reviewItem}>
            <Review review={r} intl={intl} />
          </li>
        );
      })}
    </ul>
  );
};

ReviewsComponent.defaultProps = {
  className: null,
  rootClassName: null,
  reviews: [],
};

ReviewsComponent.propTypes = {
  className: string,
  rootCalssName: string,
  reviews: arrayOf(propTypes.review),

  // from injectIntl
  intl: intlShape.isRequired,
};

const Reviews = injectIntl(ReviewsComponent);

export default Reviews;
